module.exports = __webpack_public_path__ + "static/media/kikudoo-wordmark-desat.58b3a42c.png";